exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.star-legend > div {\n    position: relative; top: -15px;\n}\n.ml-20 {\n    margin-left: 20px;\n}\n.ml-40 {\n    margin-left: 40px;\n}\n.mr-25 {\n    margin-right: 25x;\n}\n.mr-40 {\n    margin-right: 40px;\n}\n.fundoCinza {\n    background-color: lightgray !important;\n}\n\n", ""]);

// exports
